import { notification } from 'antd';
import React from 'react';

import {
  generatePropertyPinCodeDocument,
  generatePropertyPinCodeMutation,
  generatePropertyPinCodeMutationVariables,
} from '../../graphql/api/generated';
import { PermissionKey_enum } from '../../graphql/hasura/generated';

import { SendPropertyPinCode } from './components/SendPropertyPinCode';
import model from './model';

export const sendAction = model.createAction({
  label: () => 'Send',
  description: 'Send Property PIN Code to user by phone number or email',
  enabledByModel: ({ hasPermission }) => (
    hasPermission(PermissionKey_enum.User_SendMessage)
  ),
  enabledByRow: ({ assignedToUser }) => !!assignedToUser,
  renderModalContent: (pinCode, closeModal) => (
    <SendPropertyPinCode pinCode={pinCode} closeModal={closeModal}  />
  ),
  getModalProps: () => ({
    title: 'Send Property PIN Code',
    width: '50%',
    footer: null,
    destroyOnClose: true,
  }),
});

export const regenerateAction = model.createAction({
  label: () => 'Regenerate',
  enabledByModel: ({ hasPermission }) => hasPermission(PermissionKey_enum.PinCode_GenerateRandomByUser),
  // Only allowed to regenerate for registered users with readable roles
  enabledByRow: ({ assignedToUser }) => !!assignedToUser,
  confirmation: {
    title: () => 'Regenerate Random Code',
    content: () => (
      'Are you sure you want to regenerate a random code? ' +
      'This action cannot be undone.'
    ),
  },
  executes: async (pinCode, { apiClient, resetStores }) => {
    const { property, assignedToUser } = pinCode;

    if (!assignedToUser) {
      return;
    }

    await apiClient.mutate<
      generatePropertyPinCodeMutation,
      generatePropertyPinCodeMutationVariables
    >({
      mutation: generatePropertyPinCodeDocument,
      variables: {
        input: {
          propertyId: property.propertyId,
          assignedToUserId: assignedToUser.userId,
        },
      },
    });

    resetStores();

    notification.success({
      message: 'Success',
      description: 'A new code was successfully generated!',
    });
  },
});
